import React from 'react'
import SearchUI from '../../../widgets/input/SearchUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import SelectSingleSF from '../../../widgets/input/SelectSingleSF'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import OrderItemRightUI from '../order/OrderItemRightUI'
import OrderItemLeftUI from '../order/OrderItemLeftUI'
import './OrderItemList.css'

const OrderItemListUI = ({ context, messageList, order, itemList,
  searchFilter, statusList, onStatusFilterChange, statusFilter,
  onRefreshClick, onSearchFilterChange, onCreateClick, onUpdateClick
}) =>
  <div className='ord_items g_m_top_100'>
    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          context={context}
          order={order}
          messageList={messageList}
          onRefreshClick={onRefreshClick}
          onCreateClick={onCreateClick}
        />
      }
      right={
        <ActionTopRightUI
          context={context}
          messageList={messageList}
          searchFilter={searchFilter}
          onSearchFilterChange={onSearchFilterChange}
          onStatusFilterChange={onStatusFilterChange}
          statusFilter={statusFilter}
          statusList={statusList}
        />
      }
    />

    <LRTableBodyUI className='data_tbl'>
      {
        itemList.map((item, i) =>
          <ItemRowUI key={i} context={context} order={order} item={item} messageList={messageList}
            onUpdateClick={onUpdateClick} />
        )
      }
    </LRTableBodyUI>
  </div>

const ItemRowUI = ({ context, order, item, messageList, onUpdateClick }) =>
  <LRTableRowUI
    rowId={item.id}
    context={context}
    onClick={onUpdateClick}
    left={<OrderItemLeftUI context={context} item={item} messageList={messageList} />}
    right={<OrderItemRightUI context={context} item={item} messageList={messageList} />}
  />

const ActionLeftUI = ({ context, order, messageList, onRefreshClick, onCreateClick }) =>
  <div className='g_flex_h'>
    <IconButtonUI messageList={messageList} icon='icon-refresh' onClick={onRefreshClick} labelKey='c_refresh' />
    {
      context.permissions && context.permissions.includes('acc_manage') &&
      <IconButtonUI messageList={messageList} icon='icon-plus' onClick={onCreateClick} labelKey='c_add_ord_item' />
    }
  </div>

const ActionTopRightUI = ({ context, messageList, searchFilter, onSearchFilterChange,
  statusList, onStatusFilterChange, statusFilter
}) =>
  <div className='g_flex_h'>
    <SelectSingleSF
      messageList={messageList} selectedKey={statusFilter} removeKey='c_all'
      optionList={statusList.filter(status => status.value !== 'cancelled')}
      onChange={onStatusFilterChange}
    />
    <SearchUI value={searchFilter} onChange={onSearchFilterChange} />
  </div>

export default OrderItemListUI
